//node_modules
import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import { Pagination } from "react-bootstrap";

//hooks
import usePaginationContext from "../hooks/usePaginationContext";

const PaginationFirstComponent: FunctionComponent = () => {
  const handler = usePaginationContext();

  if (handler.disabled(1)) {
    return <Pagination.First disabled={true} />;
  }

  return (
    <NextLink href={handler.generatePath(1)}>
      <Pagination.First />
    </NextLink>
  );
};

export default React.memo(PaginationFirstComponent);
